
import Vue from 'vue'

import { CheckoutPageModel } from '@ViewModels/CheckoutPageModel'
import { PartyStreetAddressModel } from '@ViewModels/PartyStreetAddressModel'
import { StoreCheckoutDto } from '@ViewModels/StoreCheckoutDto'
import { formatAddress } from '../Address/AddressUtilities'

export default Vue.extend({
   name: 'BillingInputSummary',
   data() {
      return {
         step: 'payment',
      }
   },
   computed: {
      visible(): boolean {
         return (
            this.$store.state.requiresBillingAddress &&
            this.$store.getters.requiresDelivery &&
            this.$store.state.step !== this.step &&
            this.$store.state.viewedSteps.includes(this.step) &&
            !this.isSchoolOrder
         )
      },
      billingAddress(): string {
         if (this.isSchoolOrder) {
            return this.schoolAddress
         }
         if (this.personalAddress) {
            return this.personalAddress
         }
         return 'Not set'
      },
      modelData(): CheckoutPageModel {
         return this.$store.state.modelData
      },
      purchase(): StoreCheckoutDto {
         return this.$store.state.purchase
      },
      isSchoolOrder(): boolean {
         return !this.purchase.IsPersonalOrder
      },
      schoolAddress(): string {
         return this.modelData.SchoolId
            ? this.modelData.SchoolAddress
            : this.$store.state.schoolLookup.schoolAddress
      },
      personalAddress(): string {
         const addressId = this.purchase.BillingAddressId
         if (addressId) {
            const addresses = this.$store.state.modelData.Addresses
            const address = addresses.find((a: PartyStreetAddressModel) => a.Id === addressId)
            if (address) {
               return address.FormattedAddress
            }
         } else if (
            this.purchase.BillingAddress &&
            this.purchase.BillingAddress.AddressLine1 &&
            this.purchase.BillingAddress.AddressLine1.length > 2
         ) {
            return formatAddress(this.purchase.BillingAddress)
         }
         return ''
      },
   },
   methods: {
      change() {
         this.$store.commit('setStep', this.step)
      },
   },
})
